/**
 * processImpersonation — parses the ?impersonate=… query string that the
 * admin "Login as user" flow appends to the redirect URL, persists the
 * impersonation banner state into sessionStorage, and strips the query
 * params from the URL bar.
 *
 * The session cookie is ALWAYS set server-side by the impersonation
 * endpoint. We never trust a token in the URL.
 *
 * Two formats are supported for backwards compatibility:
 *   • New: `?impersonate=1&adminEmail=...&targetName=...`
 *   • Legacy: `?impersonate=<encoded JSON>` — only the adminEmail field
 *     is read; the token (if present) is ignored.
 *
 * @returns {boolean} always false (legacy reload flow removed).
 */
export const processImpersonation = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const impersonateParam = urlParams.get("impersonate");

  if (!impersonateParam) return false;

  // New format
  if (impersonateParam === "1") {
    sessionStorage.setItem("isImpersonating", "true");
    sessionStorage.setItem("impersonationAdmin", urlParams.get("adminEmail") || "Admin");
    window.history.replaceState({}, "", window.location.pathname);
    return false;
  }

  // Legacy format — only honour adminEmail; token is ignored.
  try {
    const data = JSON.parse(decodeURIComponent(impersonateParam));
    sessionStorage.setItem("isImpersonating", "true");
    sessionStorage.setItem("impersonationAdmin", data.adminEmail || "Admin");
    window.history.replaceState({}, "", window.location.pathname);
  } catch (e) {
    console.error("Error parsing impersonation data:", e);
  }
  return false;
};
